module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', [_vm._v("Cast of Characters")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('span', [_vm._v("AND THE PAGES ON WHICH THEY FIRST APPEAR")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Patience Thumm, "), _c('i', [_vm._v("Inspector Thumm’s daughter, and the narrator; a sophisticated young woman with a flair for detection")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Inspector Thumm, "), _c('i', [_vm._v("ex-inspector in charge of homicide of the New York police: now an inquiry agent")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Elihu Clay, "), _c('i', [_vm._v("a contractor in Leeds, Tilden County, who claimed to be more sinned against than sinning")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Walter Bruno, "), _c('i', [_vm._v("Governor of the state, erstwhile District Attorney of New York County, friend of Inspector Thumm, and")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Drury Lane, "), _c('i', [_vm._v("celebrated Shakespearean actor (now retired) whose brilliant feats of detection have been recorded in")]), _vm._v(" The Tragedy of X "), _c('i', [_vm._v("and")]), _vm._v(" The Tragedy of Y")]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Joel Fawcett, "), _c('i', [_vm._v("State Senator and grafter extraordinary, more surprised than anyone by his murder")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Dr. Ira Fawcett, "), _c('i', [_vm._v("Joel’s brother and Elihu Clay’s partner, whose depature from this life was as sudden, as dramatic, and as deserved as his brother’s")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Jeremy Clay, "), _c('i', [_vm._v("Elihu Clay’s son, in love with Patience")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("District Attorney John Hume, "), _c('i', [_vm._v("a shining knight in not-so-white armor")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Dr. Bull, "), _c('i', [_vm._v("Coroner and Police Doctor")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Chief Kenyon, "), _c('i', [_vm._v("Chief of Police in Leeds; the perfect picture of a heel")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Carmichael, "), _c('i', [_vm._v("Joel Fawcett’s secretary")]), _vm._v("—"), _c('i', [_vm._v("who was other things besides")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Rufus Cotton, a "), _c('i', [_vm._v("political boss, who determined that nothing should interfere with John Hume’s political future")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Fanny Kaiser, "), _c('i', [_vm._v("who made a good thing out of vice, thanks to the protection of the Fawcett brothers")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Warden Magnus, "), _c('i', [_vm._v("Warden of Algonquin prison at Leeds. His was the responsibility for Aaron Dow, and his was the failure")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Father Muir, "), _c('i', [_vm._v("Chaplain at Algonquin prison. The world was too much with him")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Aaron Dow, "), _c('i', [_vm._v("twice convicted of murder, and twice released")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Mark Currier, "), _c('i', [_vm._v("Dow’s lawyer, who would defend the devil for a price")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Park Callahan} "), _c('i', [_vm._v("prison guards who failed in their duty")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-indent"
  }, [_vm._v("Tabb, "), _c('i', [_vm._v("a trusty, assistant librarian at the prison")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45c3c9ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 75
// module chunks = 0